import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonOptions, ModelDocumentsShow } from '../../../interfaces/interfaces';
import { DialogService } from '../../../services/utils/dialog.service';
import { EmployerService } from '../../../services/modules/employer.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CropperComponent } from 'angular-cropperjs';
import { AuthService } from 'src/app/core/services/modules/auth.service';
import { User } from 'src/app/core/models/User';
import { CommonService } from 'src/app/core/services/modules/common.service';
import { FechasService } from 'src/app/core/services/utils/fechas.service';
import {SnackBarService} from '../../../services/utils/snackBar.service';
import {CompaniesService} from '../../../services/modules/companies.service';


export interface DialogData {
  title: string;
  docs: ModelDocumentsShow[];
  typeOperator: string;
  idPlanilla: number;
  typeGestor: string;
  cropper?: boolean;
  desc: string;
  proveedorId: boolean;
  permissions: string[];
  permissionCompany: string[];
  isFromPersonal: boolean;
  companyInfoId: string;

  requirement?: {
    Name?: string;
    RequirementName?: string;
    Type?: string;
    RequirementCode?: string | number;
    RequirementId?: string | number;
    ByDate?: boolean;
    IsDate?: boolean;
  };
}

interface DurationOption {
  Id: string | number;
  Translation: string;
}

@Component({
  selector: 'app-dialog-gestor-img',
  templateUrl: './dialog-gestor-img.component.html',
  styleUrls: ['./dialog-gestor-img.component.scss']
})
export class DialogGestorImgComponent implements OnInit {
  private static readonly EXCLUDED_BY_DATE = new Set(['EPS', 'ARL', 'AFP']);
  @ViewChild('angularCropper') angularCropper: CropperComponent;
  userAuth: User;
  s3Bucket: string;
  file: File = null;
  email = '';
  DocsJSON: any = {};
  imgCropper: string;
  formFile: FormGroup;
  formDate!: FormGroup;
  upDateDocuments: any;
  commentary = '';
  cropper = false;
  imgCropperResult: string;
  canUpdateDate = false;
  loadingDuration = false;

  files: File[] = [];
  documentos: any[] = [];
  proveedor: CommonOptions[] = [];
  durationOptions: DurationOption[] = [];

  formData = new FormData();
  controProveedor = new FormControl();
  today = new Date(new Date().setHours(0, 0, 0, 0));

  proveedorURLS = [
    {Value: 'ARU', urlAssets: 'assets/images/ImagenFormatoArus.png', urlComplet: 'https://analityco-acceso.s3.amazonaws.com/assets/images/ImagenFormatoArus.png'},
    {Value: 'APT', urlAssets: 'assets/images/ImagenFormatoAportesEnLinea.png', urlComplet: 'https://analityco-acceso.s3.amazonaws.com/assets/images/ImagenFormatoAportesEnLinea.png'},
    {Value: 'MIP', urlAssets: 'assets/images/ImagenFormatoMiPlanilla.png', urlComplet: 'https://analityco-acceso.s3.amazonaws.com/assets/images/ImagenFormatoMiPlanilla.png'},
    {Value: 'ASO', urlAssets: 'assets/images/ImagenFormatoAsopagos.png', urlComplet: 'https://analityco-acceso.s3.amazonaws.com/assets/images/ImagenFormatoAsopagos.png'}
  ];

  private readonly MAX_BYTES = 5_000_000;
  private originalBytes: number | null = null;

  constructor(
    private dialogRef: MatDialogRef<DialogGestorImgComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogService: DialogService,
    private employerService: EmployerService,
    private fb: FormBuilder,
    private authService: AuthService,
    private commonService: CommonService,
    private fechasService: FechasService,
    private snackBService: SnackBarService,
    private companiesServices: CompaniesService,
  ) {
    this.userAuth = this.authService.getUser();
    this.email = this.userAuth?.Email !== null && this.userAuth?.Email !== undefined ? this.userAuth?.Email : '';
    this.formFile = this.fb.group({
      File: ''
    });
    if (this.data.cropper) {
      this.cropper = this.data.cropper;
    }
    if (this.data.typeOperator === 'uploadProveedor') {
      this.commonService.getCommonOptions('PlanillaProvider')
        .subscribe((options: CommonOptions[]) => {
          this.proveedor = options;
        });
    }
    this.formDate = this.fb.group({
      DatePreparation: [null],
      expireProjection: [null, Validators.required],
    });
    // Inicializar ambos controles como deshabilitados por defecto
    this.formDate.get('DatePreparation')?.disable({ emitEvent: false });
    this.formDate.get('expireProjection')?.disable({ emitEvent: false });
  }

  ngOnInit(): void {
    const isContractStagesModule = this.isFromContractStagesModule();

    if (isContractStagesModule) {
      this.canUpdateDate = this.exitPermission('contractstagesrequirements.updatedate');
    } else {
      this.canUpdateDate = true;
    }

    if (this.canUpdateDate) {
      this.formDate.get('DatePreparation')?.enable({ emitEvent: false });
    } else {
      this.formDate.get('DatePreparation')?.disable({ emitEvent: false });
      this.formDate.get('expireProjection')?.disable({ emitEvent: false });
    }

    this.s3Bucket = environment.api.s3Bucket;
    this.data.docs.forEach(doc => {
      if (this.getName(doc).includes('commentary_fileAnalityco.txt')){
        const archivo = new XMLHttpRequest();
        archivo.open('GET', this.s3Bucket + this.getUrl(doc), false);
        archivo.send(null);
        const data = this.getSplitDoc(doc);
        for (let index = 0; index < data.length; index++) {
            if (index === 0) {
              doc.urlDoc = data[index];
            }
            if (index === 1) {
              setTimeout(() => {
                doc.nameFile = archivo.responseText;
              }, 300);
            }
            if (index === 2) {
              doc.user = data[index];
            }
            if (index === 3) {
              doc.date = data[index];
            }
        }
        doc.isCommentary = true;
      } else {
        const data = this.getSplitDoc(doc);
        for (let index = 0; index < data.length; index++) {
            if (index === 0) {
              doc.urlDoc = data[index];
            }
            if (index === 1) {
              doc.nameFile = data[index];
            }
            if (index === 2) {
              doc.user = data[index];
            }
            if (index === 3) {
              doc.date = data[index];
            }
            if (index === 4) {
              doc.module = data[index];
            }
            if (index === 5) {
              doc.module_id = data[index];
            }
            if (index === 6) {
              doc.module_state = data[index];
            }
            if (index === 7) {
              doc.module_comment = data[index];
            }
            if (index === 8) {
              doc.module_date = data[index];
            }
        }
        doc.isCommentary = false;
      }
      this.documentos.push(doc);
    });
    this.documentos.reverse();
    this.dialogRef.afterOpened().subscribe(() => {
      this.loadDurationOptions();
    });
  }

  private loadDurationOptions(): void {
    const requirementId = this.resolveRequirementId();
    if (!requirementId) { this.loadingDuration = false; return; }

    this.loadingDuration = true;
    const ctrl = this.formDate.get('expireProjection');

    this.companiesServices.getRequirementsConfigured(requirementId, this.data.companyInfoId).subscribe({
      next: (options: any[]) => {
        const norm = (options ?? [])
          .map((o: any) => ({
            Id: o?.Id ?? o?.Value ?? o?.id ?? o?.value,
            Translation: o?.Translation ?? o?.Name ?? o?.translation ?? o?.name
          })).filter((o: any) => o.Id != null && !!o.Translation);

        this.durationOptions = norm;

        if (this.durationOptions.length) {
          if (this.canUpdateDate) {
            ctrl?.enable({ emitEvent: false });
          } else {
            ctrl?.disable({ emitEvent: false });
          }

          if (!ctrl?.value) {
            ctrl?.setValue(this.durationOptions[0].Id, { emitEvent: false });
          }
        } else {
          ctrl?.disable({ emitEvent: false });
        }
      },
      error: () => {
        this.durationOptions = [];
        Promise.resolve().then(() => ctrl?.disable({ emitEvent: false }));
        this.snackBService.openWarning('No fue posible cargar las opciones de vencimiento.', '', 4000);
      },
      complete: () => { this.loadingDuration = false; }
    });
  }

  private resolveRequirementId(): string | number | null {
    const r = this.data?.requirement ?? {};
    return (r as any).RequirementId
      ?? (r as any).RequirementCode
      ?? (r as any).Id
      ?? (r as any).id
      ?? (r as any).Code
      ?? (r as any).code
      ?? null;
  }

  private getDurationOptionId(): string | number | null {
    return this.formDate.get('expireProjection')?.value ?? null;
  }

  private getBaseDateFormatted(): string {
    const dateCtrl = this.formDate.get('DatePreparation')?.value;

    if (!dateCtrl) {
      return '';
    }

    const d = new Date(dateCtrl);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  exitPermissionCompany(permiso: string): boolean {
    let exit = false;
    const permisionsUserInfo  = this.data?.permissionCompany?.find(x => x === permiso);
    permisionsUserInfo !== undefined ? exit = true : exit = false;
    return exit;
  }
  exitPermission(permiso: string): boolean {
    let exit = false;
    const permisionsUserInfo  = this.data?.permissions?.find(x => x === permiso);
    permisionsUserInfo !== undefined ? exit = true : exit = false;
    return exit;
  }

  /**
   * Verifica si el diálogo fue abierto desde el módulo de solicitudes (contractstagesrequirements).
   * Se detecta verificando si hay permisos relacionados con 'contractstagesrequirements' en la lista de permisos.
   * @returns true si estamos en el módulo de solicitudes, false en caso contrario
   */
  private isFromContractStagesModule(): boolean {
    if (!this.data?.permissions || !Array.isArray(this.data.permissions)) {
      return false;
    }
    return this.data.permissions.some(p => p?.startsWith('contractstagesrequirements.'));
  }

  openImgVideo(doc: ModelDocumentsShow) {
    window.open(this.s3Bucket + this.getUrl(doc), '_blank');
    // Se comenta el componente que muestra en modal los videos he imagenes para poderlos abrir en otra ventana 15/09/2022
    // this.dialogService.openDialogImageOrVideoOrPdf(this.getUrl(doc)).afterClosed().subscribe(x => {});
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getDateFormatDateYYYYMMDDdatePiker(date): string {
    let response = '';
    if (date !== null && date !== null) {
      let data;
      data = this.fechasService.formatDateYYYYMMDDdatePiker(date);
      response = this.fechasService.getDateFormatR(data);
    }
    return response;
  }

  getDateFormatDateGestorDocuemntsUpdate(date): string {
    let response = '';
    if (date !== null && date !== null && date !== undefined) {
      response = this.fechasService.formatDateYYYYMMDDdatePikerWhitMinutes(date);
    }
    return response;
  }

  getSplitDoc(doc: ModelDocumentsShow) {
    let name: any = '';
    if (doc) {
      const a = doc.urlDoc.split('||');
      for (let index = 0; index < a.length; index++) {
        if (index === 1)  {
          a[index] = a[index].replace('name=', '');
        }
        if (index === 2) {
          a[index] = a[index].replace('user=', '');
        }
        if (index === 3) {
          a[index] = a[index].replace('date=', '');
        }
        if (index === 4) {
          a[index] = a[index].replace('module=', '');
        }
        if (index === 5) {
          a[index] = a[index].replace('module_id=', '');
        }
        if (index === 6) {
          a[index] = a[index].replace('module_state=', '');
        }
        if (index === 7) {
          a[index] = a[index].replace('module_comment=', '');
        }
        if (index === 8) {
          a[index] = a[index].replace('module_date=', '');
        }
        if (index === a.length - 1) {
          name = a;
        }
      }
    }
    return name;
  }

  getName(doc: ModelDocumentsShow) {
    let name = '';
    if (doc) {
      const a = doc.urlDoc.split('||name=');
      name = a[1];
    }
    return name;
  }

  getUrl(doc: ModelDocumentsShow): string {
    let url = '';
    const a = doc?.urlDoc?.split('||name=');
    if (a !== undefined) {
      url = a[0];
    }
    return url;
  }

  jsonUpdateDeleteDoc(doc: ModelDocumentsShow, index) {
    const DocsJSON = `{"${doc.name}": "${doc.urlDoc}"}`;
    const a = JSON.parse(DocsJSON);
    Object.assign(this.DocsJSON, a);
    delete this.documentos[index];
  }

  jsonDocExitValue(): boolean {
    return Object.entries(this.DocsJSON).length === 0;
  }

  upDateDocs(DocsJSON) {
    const durationOptionId = this.getDurationOptionId();
    const baseDate = this.getBaseDateFormatted();
    if (this.data.typeOperator === 'showDelete' || this.data.typeOperator === 'showUpdate') {
      this.dialogRef.close({DocsJSON, files: this.files, commentary: this.commentary, durationOptionId,
        baseDate});
    } else if (!this.jsonDocExitValue() && this.data.typeOperator === 'showUpdatePlanilla') {
      this.upDateDocuments = {Id: this.data.idPlanilla,  DocsJSON};
      this.employerService.updateDocsJsonPlanilla(this.data.idPlanilla, this.upDateDocuments).subscribe((rest: any) => {
        if (this.files.length > 0 || this.commentary !== '') {
          this.saveFiles();
        }
        this.dialogRef.close(rest.DocsJSON);
      });
    } else if (this.files.length > 0 || this.commentary !== '') {
      this.saveFiles();
    }
  }

  saveFiles(): void {
    const durationOptionId = this.getDurationOptionId();
    const baseDate = this.getBaseDateFormatted();

    for (let i = 0; i < this.files.length; i++) {
      const formData = new FormData();

      if (this.commentary !== '' && this.commentary != null) {
        formData.append('commentary', this.commentary);
      }
      formData.append('File', this.files[i]);

      this.employerService.updateFilesocialSecurity(this.data.idPlanilla, formData).subscribe((rest: any) => {
          if (i === this.files.length - 1) {
            this.dialogRef.close({DocsJSON: rest?.DocsJSON, durationOptionId, baseDate});
          }
        });
    }

    if (this.files.length === 0 && this.commentary && this.commentary !== '') {
      this.employerService.updateCommentsocialSecurityCommentary(this.data.idPlanilla, this.commentary).subscribe((rest: any) => {
          this.dialogRef.close({DocsJSON: rest?.DocsJSON, durationOptionId, baseDate});
        });
    }
  }

  private isAllowedFile(f: File): boolean {
    const type = (f?.type || '').toLowerCase();
    const name = (f?.name || '').toLowerCase();
    const allowedMimes = ['application/pdf', 'image/jpeg', 'image/png'];
    const allowedExt = /\.(pdf|jpe?g|png)$/i.test(name);
    return allowedMimes.includes(type) || allowedExt;
  }

  private showInvalidTypeSnack(): void {
    this.snackBService.openWarning('Solo se permite subir archivos en formatos PDF, JPG, PNG.', '', 5000);
  }


  // METODOS PARA CORTAR UNA IMAGEN Y GUARDARLA
  onSelect(event: { addedFiles: File[], rejectedFiles?: File[] }): void {
    const selected = event.addedFiles || [];
    const rejectedByAccept = event.rejectedFiles || [];

    if (rejectedByAccept.length) {
      this.showInvalidTypeSnack();
    }

    if (!selected.length) { return; }

    this.originalBytes = selected[0]?.size ?? null;

    const valid: File[] = [];
    const invalid: File[] = [];
    for (const f of selected) {
      (this.isAllowedFile(f) ? valid : invalid).push(f);
    }

    if (invalid.length) {
      this.showInvalidTypeSnack();
    }

    if (!valid.length) { return; }

    if (this.cropper === false) {
      for (const f of valid) { this.files.push(f); }
      return;
    }

    if (this.cropper === true &&
      (this.data.typeOperator === 'showDelete' || this.data.typeOperator === 'showUpdate')) {
      for (const f of valid) { this.files.push(f); }
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.imgCropper = reader.result as string;
      this.imgCropperResult = reader.result as string;
    };
    reader.readAsDataURL(valid[0]);
  }

  updatePhoto() {
    const MAX = 15 * 1024 * 1024;
    this.cropper = false;
    const durationOptionId = this.getDurationOptionId();
    const baseDate = this.getBaseDateFormatted();

    if (this.originalBytes !== null && this.originalBytes > MAX) {
      this.snackBService.openWarning('El archivo supera el peso máximo permitido de 15 MB', '', 5000);
      return;
    }

    if (this.imgCropper !== undefined) {
      const cropper = this.angularCropper?.cropper;
      const canvas = cropper?.getCroppedCanvas?.({ maxWidth: 2000, maxHeight: 2000 });

      if (!canvas) {
        this.snackBService.openWarning('No se pudo obtener la imagen recortada.', '', 5000);
        return;
      }

      this.imgCropperResult = canvas.toDataURL('image/jpeg', 0.95);

      canvas.toBlob((blob) => {
        if (!blob) {
          this.snackBService.openWarning('No se pudo procesar la imagen.', '', 5000);
          return;
        }

        if (blob.size > MAX) {
          this.snackBService.openWarning('El archivo supera el peso máximo permitido de 15 MB', '', 5000);
          return;
        }

        const fileOut = new File([blob], `logo_${Date.now()}.jpg`, { type: 'image/jpeg' });
        const fd = new FormData();
        fd.append('File', fileOut, fileOut.name);

        this.dialogRef.close({FormData: fd, imgResult: this.imgCropperResult, commentary: this.commentary,
          meta: { originalBytes: this.originalBytes, finalBytes: fileOut.size },
          durationOptionId,
          baseDate
        });
      }, 'image/jpeg', 0.95);
      return;
    }
  }

  isEqualsUserRemoveFile(doc): boolean {
    let equal = false;
    this.userAuth.username === doc?.user ? equal = true : equal = false;
    return equal;
  }

  removeFile(index) {
    this.files.splice(index, 1);
  }

  isXLSX(doc: any): boolean {
    return this.getUrl(doc).slice(-5).toUpperCase() === '.XLSX';
  }

  getUrlFile(url) {
    const urlFile = this.s3Bucket + this.getUrl(url);
    return urlFile;
  }

  selectedProveedor(e) {
    const data = this.arrayURLSProveedor(e);
    this.dialogService.openDialogDialogConfirmImg('REQUERIMIENTOS DEL DOCUMENTO A CARGAR',
                                                  [ '1. Solo cargar documentos en PDF',
                                                    '2. Solo cargar documentos generado directamente con la plataforma del operador PILA, No se aceptan fotocopias.',
                                                    '3. Solo cargar documentos en fomato indicado por la imagen.'
                                                  ],
                                                  data.urlComplet,
                                                  data.urlAssets
      ).afterClosed().subscribe(confirm => {

    });
  }

  arrayURLSProveedor(Id): URLproveedor {
    let result: URLproveedor;

    const dataProveedor = this.proveedor.find(x => x.Id === Id);
    const dataProveedorURLS = this.proveedorURLS.find(
      x => x.Value === dataProveedor?.Value
    );

    if (dataProveedorURLS !== undefined) {
      result = dataProveedorURLS;
    } else {
      result = { Value: '', urlAssets: '', urlComplet: '' };
    }

    return result;
  }


  private getRequirementKey(r: any): string {
    return (r?.RequirementName ?? r?.Name ?? r?.Type ?? r?.RequirementCode ?? r?.RequirementId ?? '')
      .toString().trim().toUpperCase();
  }

  private isExcludedByDate(r: any): boolean {
    return DialogGestorImgComponent.EXCLUDED_BY_DATE.has(this.getRequirementKey(r));
  }

  shouldShowDateFieldsFromDialog(): boolean {
    const r = this.data?.requirement;
    return !!(r?.ByDate || r?.IsDate) && !this.isExcludedByDate(r);
  }
}

export interface URLproveedor {
  Value: string;
  urlComplet: string;
  urlAssets: string;
}
